import { AsyncMetaState } from '@mews/framework';
import { PortfolioEnterpriseWithRateCount } from '@mews-commander/data-access';
import { WithDefaultPolicy } from '../rateGroups/types';

export type MetaState = AsyncMetaState;

export interface WithEnterpriseIds {
    enterpriseIds: string[];
}

export interface WithVoucherIds {
    voucherIds?: string[];
}

export enum DataType {
    RateType = 'RateType',
    VoucherType = 'VoucherType',
}
export interface ServerSyncState {
    isInitialized: {
        [DataType.RateType]: boolean;
        [DataType.VoucherType]: boolean;
    };
    dataType: DataType | null;
    dataToFetch: string | null;
    shouldFetch: boolean;
}

export interface FieldsConfig<T> {
    disabledFields?: Array<T>;
    lockedFields?: Array<T>;
    enabledFields?: Array<T>;
}

export interface WithFieldsConfig<T> {
    fieldsConfig?: FieldsConfig<T>;
}

export interface FormErrors<T = Record<string, unknown>> {
    field: keyof T;
    message: string;
}

export type RateGroupFormStep = 'paymentPolicies' | 'details';

export enum DetailsFieldName {
    ServiceKey = 'serviceKey',
    RateGroupType = 'rateGroupType',
    Service = 'service',
    Name = 'name',
    ShortName = 'shortName',
    Description = 'description',
    RateGroupKey = 'rateGroupKey',
    Ordering = 'ordering',
}

export enum ConfigurationFieldName {
    MaximumTime = 'settlementMaximumTimeUnits',
    Extent = 'settlementExtent',
    Options = 'options',
}

export enum RateGroupType {
    Central = 'central',
    Local = 'local',
}

export interface SelectedRateGroup extends WithDefaultPolicy {
    id: string;
    rateGroupKey?: string | null;
    property?: string | null;
    serviceKey?: string | null;
    name: string;
    shortName?: string | null;
    description?: string | null;
    ordering: number;
    isLocal: boolean;
    isPortfolioManaged?: boolean;
    bookablePeriod?: 'Month' | 'Night' | 'Day' | 'Hour';
    settlementExtent: Array<'TimeUnits' | 'Products' | 'AdditionalExpenses'>;
    settlementMaximumTimeUnits?: number | null;
    options: Array<'AutomaticDepositSettlement' | 'CreateSettlementTask' | 'RequirePaymentCardDuringOnlineCheckIn'>;
    createdUtc: string;
    updatedUtc: string;
    propertiesWithRateCounts?: Array<PortfolioEnterpriseWithRateCount> | null;
}
